import { useState, useEffect } from "react";
import { LineChart, Line, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import { II } from "../../components/common/Icons";
import { usePMData } from "../../context/PMContext";
import { useAuth } from "../../context/AuthContext";import "../../assets/styles/PM/PMDashPg.css";

function PMDashPg() {
  const {
    pmProjects,
    pmTeamMembers,
    pmLeaveReqs,
    pmDocs,
    pmHrReports,
    pmAnnouncements,
    pmSchedules,
    assignedHR,
    dashboardStats,
    loading,
    refreshPMData
  } = usePMData();

  const { user } = useAuth();
  const [projectProgressData, setProjectProgressData] = useState([]);
  const [recentAnnouncements, setRecentAnnouncements] = useState([]);

  const activeProjects = pmProjects?.filter((p) =>
  p.status !== 'Completed' && p.status !== 'On Hold'
  ).length || 0;

  const completedProjects = pmProjects?.filter((p) =>
  p.status === 'Completed'
  ).length || 0;

  const totalMembers = pmTeamMembers?.length || 0;

  const membersOnTrack = pmTeamMembers?.filter((m) =>
  m.status === 'On Track'
  ).length || 0;

  const needsAttention = pmTeamMembers?.filter((m) =>
  m.status === 'Needs Attention' || m.status === 'Behind'
  ).length || 0;

  const avgProgress = pmProjects?.length ?
  Math.round(pmProjects.reduce((acc, p) => acc + (p.progress || 0), 0) / pmProjects.length) :
  0;

  useEffect(() => {
    if (pmAnnouncements && pmAnnouncements.length > 0) {
      const sorted = [...pmAnnouncements].
      sort((a, b) => new Date(b.created_at) - new Date(a.created_at)).
      slice(0, 3);
      setRecentAnnouncements(sorted);
    }
  }, [pmAnnouncements]);

  useEffect(() => {
    if (pmProjects && pmProjects.length > 0) {
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'];
      const data = months.map((month) => {
        const monthProjects = pmProjects.filter((p) => {
          const startMonth = p.start?.split(' ')[0];
          return startMonth === month;
        });
        const avgProgress = monthProjects.length ?
        Math.round(monthProjects.reduce((acc, p) => acc + p.progress, 0) / monthProjects.length) :
        0;
        return { month, progress: avgProgress };
      });
      setProjectProgressData(data);
    }
  }, [pmProjects]);

  if (loading) {
    return (
      <div className="pmdashpg-inline-1">
        <div className="ob-pending-dot pmdashpg-inline-2"></div>
        <div className="pmdashpg-inline-3">Loading dashboard data from database...</div>
      </div>);

  }

  return (
    <div>
      <div className="sec">
        <span>Project Command Center</span>
        <span className="pmdashpg-inline-4">
          Welcome back, {user?.name || 'PM'}
        </span>
      </div>
      
      <div className="kpi">
        {[
        {
          l: "Active Projects",
          v: String(activeProjects),
          ch: `${completedProjects} completed`,
          cl: "#7c3aed"
        },
        {
          l: "Team Members",
          v: String(totalMembers),
          ch: `${membersOnTrack} on track · ${needsAttention} need attention`,
          cl: "#2563eb"
        },
        {
          l: "Pending Actions",
          v: String((dashboardStats.pendingLeaves || 0) + (dashboardStats.pendingDocs || 0) + (dashboardStats.pendingReports || 0) + (dashboardStats.pendingAdvances || 0)),
          ch: `${dashboardStats.pendingLeaves || 0} leave · ${dashboardStats.pendingDocs || 0} docs · ${dashboardStats.pendingReports || 0} reports · ${dashboardStats.pendingAdvances || 0} advances`,
          cl: "#d97706"
        },
        {
          l: "Avg Progress",
          v: `${avgProgress}%`,
          ch: `Across ${(pmProjects || []).length} projects`,
          cl: "#2563eb"
        },
        {
          l: "Upcoming",
          v: String(dashboardStats.upcomingSchedules),
          ch: "Scheduled meetings",
          cl: "#4338ca"
        }].
        map((k, i) =>
        <div key={i} className="kpi-c pmdashpg-dyn-1" style={{ "--pmdashpg-1-border-left": "3px solid " + k.cl }}>
            <div className="kpi-v pmdashpg-dyn-2" style={{ "--pmdashpg-2-color": k.cl }}>{k.v}</div>
            <div className="kpi-l">{k.l}</div>
            <div className="kpi-ch pmdashpg-dyn-3" style={{ "--pmdashpg-3-color": k.cl }}>{k.ch}</div>
          </div>
        )}
      </div>

      <div className="g2 mb16">
        <div className="cd">
          <div className="cd-h">
            <div className="cd-t">Your Projects</div>
            <div className="cd-s">{(pmProjects || []).length} total · {activeProjects} active</div>
          </div>
          <div className="cd-b">
            {(pmProjects || []).length === 0 ?
            <div className="pmdashpg-inline-5">
                No projects assigned. Create your first project.
              </div> :

            (pmProjects || []).slice(0, 4).map((p) =>
            <div key={p.pid} className="pf">
                  <div>
                    <div className="pmdashpg-inline-6">{p.name}</div>
                    <div className="pmdashpg-inline-7">
                      {p.pid} · {p.client} · Due {p.deadline || 'TBD'}
                    </div>
                    {p.hr_name &&
                <div className="pmdashpg-inline-8">
                        HR: {p.hr_name}
                      </div>
                }
                  </div>
                  <div className="pmdashpg-inline-9">
                    <div className="pmdashpg-inline-10">
                      <div style={{ "--pmdashpg-4-width":


                    p.progress + "%", "--pmdashpg-4-background":
                    p.progress >= 70 ? "#2563eb" : p.progress >= 40 ? "#d97706" : "#ef4444" }} className="pmdashpg-dyn-4" />

                  
                  
                    </div>
                    <span style={{ "--pmdashpg-5-color":


                  p.progress >= 70 ? "#2563eb" : p.progress >= 40 ? "#d97706" : "#ef4444" }} className="pmdashpg-dyn-5">
                  
                      {p.progress}%
                    </span>
                  </div>
                </div>
            )
            }
          </div>
        </div>

        <div className="cd">
          <div className="cd-h">
            <div className="cd-t">Pending Actions</div>
            <div className="cd-s">{(dashboardStats.pendingLeaves || 0) + (dashboardStats.pendingDocs || 0) + (dashboardStats.pendingReports || 0) + (dashboardStats.pendingAdvances || 0)} need review</div>
          </div>
          <div className="cd-b pmdashpg-inline-11">
            {(dashboardStats.pendingLeaves || 0) === 0 && (dashboardStats.pendingDocs || 0) === 0 && (dashboardStats.pendingReports || 0) === 0 && (dashboardStats.pendingAdvances || 0) === 0 ?
            <div className="pmdashpg-inline-12">
                ✓ All caught up! No pending actions.
              </div> :

            <>
                {dashboardStats.pendingLeaves > 0 &&
              <div className="pf pmdashpg-inline-13">
                    <div>
                      <div className="pmdashpg-inline-14">Leave Requests</div>
                      <div className="pmdashpg-inline-15">
                        {dashboardStats.pendingLeaves} request{dashboardStats.pendingLeaves !== 1 ? 's' : ''} pending approval
                      </div>
                    </div>
                    <span className="chip chip-wn">{dashboardStats.pendingLeaves}</span>
                  </div>
              }
                {dashboardStats.pendingDocs > 0 &&
              <div className="pf pmdashpg-inline-16">
                    <div>
                      <div className="pmdashpg-inline-17">Document Reviews</div>
                      <div className="pmdashpg-inline-18">
                        {dashboardStats.pendingDocs} document{dashboardStats.pendingDocs !== 1 ? 's' : ''} pending review
                      </div>
                    </div>
                    <span className="chip chip-wn pmdashpg-inline-19">{dashboardStats.pendingDocs}</span>
                  </div>
              }
                {dashboardStats.pendingReports > 0 &&
              <div className="pf">
                    <div>
                      <div className="pmdashpg-inline-20">HR Reports</div>
                      <div className="pmdashpg-inline-21">
                        {dashboardStats.pendingReports} report{dashboardStats.pendingReports !== 1 ? 's' : ''} to review
                      </div>
                    </div>
                    <span className="chip chip-wn pmdashpg-inline-22">{dashboardStats.pendingReports}</span>
                  </div>
              }
                {(dashboardStats.pendingAdvances || 0) > 0 &&
              <div className="pf">
                    <div>
                      <div className="pmdashpg-inline-23">Salary Advances</div>
                      <div className="pmdashpg-inline-24">
                        {dashboardStats.pendingAdvances} request{dashboardStats.pendingAdvances !== 1 ? 's' : ''} pending manager approval
                      </div>
                    </div>
                    <span className="chip chip-wn pmdashpg-inline-25">{dashboardStats.pendingAdvances}</span>
                  </div>
              }
              </>
            }
          </div>
        </div>
      </div>

      <div className="g2 mb16">
        <div className="cd">
          <div className="cd-h">
            <div className="cd-t">Team Status</div>
            <div className="cd-s">{totalMembers} members · {needsAttention} need attention</div>
          </div>
          <div className="cd-b">
            {(pmTeamMembers || []).length === 0 ?
            <div className="pmdashpg-inline-26">
                No team members assigned to your projects.
              </div> :

            (pmTeamMembers || []).slice(0, 5).map((m, i) =>
            <div key={i} className="pf">
                  <div>
                    <div className="pmdashpg-inline-27">{m.name}</div>
                    <div className="pmdashpg-inline-28">
                      {m.role} · {m.project_name}
                    </div>
                  </div>
                  <div className="pmdashpg-inline-29">
                    <div className="pmdashpg-inline-30">
                      <div style={{ "--pmdashpg-6-width":


                    m.progress + "%", "--pmdashpg-6-background":
                    m.status === "On Track" ? "#2563eb" : "#d97706" }} className="pmdashpg-dyn-6" />

                  
                  
                    </div>
                    <span
                  className="chip pmdashpg-dyn-7" style={{ "--pmdashpg-7-background":

                    m.status === "On Track" ? "#eff6ff" : "#fff7ed", "--pmdashpg-7-color":
                    m.status === "On Track" ? "#2563eb" : "#d97706", "--pmdashpg-7-border-color":
                    m.status === "On Track" ? "#bfdbfe" : "#fed7aa" }}>
                  
                  
                      {m.status}
                    </span>
                  </div>
                </div>
            )
            }
          </div>
        </div>

        <div className="cd">
          <div className="cd-h">
            <div className="cd-t">Recent Announcements</div>
            <div className="cd-s">{(pmAnnouncements || []).length} total</div>
          </div>
          <div className="cd-b">
            {recentAnnouncements.length === 0 ?
            <div className="pmdashpg-inline-31">
                No announcements yet.
              </div> :

            recentAnnouncements.map((a, i) =>
            <div key={a.id} style={{ "--pmdashpg-8-border-bottom":

              i < recentAnnouncements.length - 1 ? "1px solid #f1f5f9" : "none" }} className="pmdashpg-dyn-8">
              
                  <div className="pmdashpg-inline-32">
                    <span className={`${"chip " + (
                a.type === "meeting" ? "chip-ip" :
                a.type === "milestone" ? "chip-p" :
                "chip-wn")} pmdashpg-dyn-9`}>
                  
                      {a.type}
                    </span>
                    <span className="pmdashpg-inline-34">{a.title}</span>
                  </div>
                  <div className="pmdashpg-inline-35">
                    {(a.body || '').length > 80 ? (a.body || '').substring(0, 80) + '...' : a.body || ''}
                  </div>
                  <div className="pmdashpg-inline-36">
                    {a.project_name} · {a.date || new Date(a.created_at).toLocaleDateString('en-IN', { day:'2-digit', month:'short', year:'numeric' })} · by {a.created_by}
                  </div>
                </div>
            )
            }
          </div>
        </div>
      </div>

      {(pmProjects || []).length > 0 &&
      <div className="cd">
          <div className="cd-h">
            <div className="cd-t">Project Progress Trend</div>
            <div className="cd-s">Last 6 months</div>
          </div>
          <div className="cd-b pmdashpg-inline-37">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={projectProgressData.length > 0 ? projectProgressData : [
            { month: 'Jan', progress: 0 },
            { month: 'Feb', progress: 0 },
            { month: 'Mar', progress: 0 }]
            }>
                <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
                <XAxis dataKey="month" tick={{ fontSize: 11 }} stroke="#94a3b8" />
                <YAxis tick={{ fontSize: 11 }} stroke="#94a3b8" domain={[0, 100]} />
                <Tooltip
                contentStyle={{
                  borderRadius: 8,
                  border: "1px solid #e2e8f0",
                  fontSize: 12
                }} />
              
                <Line
                type="monotone"
                dataKey="progress"
                stroke="#7c3aed"
                strokeWidth={2.5}
                dot={{ r: 4 }}
                name="Avg Progress %" />
              
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      }
    </div>);

}

export default PMDashPg;